import { Utils } from "ng/src/app/core/utils";
import { TemplateContainer, ContainerEntry, ReadonlyContainerEntry, TemplateContainerCreationResult } from "ng/src/app/templates/shared/template-container/template-container.model";
import { Template, TemplateSegment, TemplateSegmentTypeId, TemplateTypeId } from "ng/src/app/templates/shared/template.model";

export class SectionalContainer extends TemplateContainer {
	
	protected create(template: Template, segments: TemplateSegment[]): TemplateContainerCreationResult {
		const self = this;
		if (template.templateType.id !== TemplateTypeId.INSPECTION) {
			return this.createResult();
		}
		
		const sorted = segments.filter(s => s.templateId === template.id)
			.sort(Utils.createSortFunction('sortOrder'));
		
		const map: Record<number, ContainerEntry> = {};
		
		
		let current: ContainerEntry = self.createEntry({
			idx: 0,
			originIdx: 0,
			entries: []
		});
		map[-1] = current;
		
		const sections: ( typeof current )[] = [current];
		
		sorted.forEach((segment, idx) => {
			if (segment.type.id !== TemplateSegmentTypeId.SUB_TEMPLATE) {
				current.entries.push(createEntry(segment, current.entries.length, current));
				return;
			}
			
			if (idx === 0) {
				sections.splice(0, 1);
				delete map[-1];
			}
			
			const newLevel = segment.level!;
			if (newLevel > current.segment?.level!) {
				Utils.let(current, (oldCurrent) => {
					current = createEntry(segment, oldCurrent.entries.length, oldCurrent);
					
					oldCurrent.entries.push(current)
				});
			}
			else {
				goUpToLevel(newLevel - 1);
				
				const arr = newLevel === 1 ? sections : current.entries;
				current = createEntry(segment, arr.length, newLevel == 1 ? undefined : current);
				
				arr.push(current);
				
			}
			
			function createEntry(segment: TemplateSegment, localIdx: number, parent?: ContainerEntry): ContainerEntry {
				const entry = self.createEntry({
					originIdx: idx,
					idx: localIdx,
					entries: [],
					segment,
					...parent && {
						parent
					}
				});
				
				map[segment.id ?? -1] = entry;
				return entry;
			}
			
		});
		
		const arr: ReadonlyArray<ReadonlyContainerEntry> = Object.freeze(
			sections.map(e => freezeEntry(e))
		);
		
		return this.createResult(arr, Object.freeze(map));
		
		function goUpToLevel(level: number) {
			while ((current.segment?.level ?? 0) > level && current.parent) {
				current = current.parent as typeof current;
			}
		}
		
		function freezeEntry(entry: ContainerEntry): ReadonlyContainerEntry {
			entry.entries.map(e => freezeEntry(e));
			return Object.freeze(entry);
		}
	}
	
	viewableInNonObsoleteView(entry: ReadonlyContainerEntry): boolean {
		return entry.segment?.obsolete !== true;
	}
}